import { Component, signal } from '@angular/core';
import { Record } from '@common/data-models/records/record';
import { TreeLikeFlatNode } from '@src/suite/common/data-models/search-results/search-results';

import { EnpsComponent } from './enps-component';

@Component({
    template: '',
})
export class DroppableEnpsComponent extends EnpsComponent {
    appendOnly = signal(false);
    dragStarted = signal(false);
    sourceGuid = signal(null);
    sourceGroup = signal(null);
    targetGuid = signal(null);
    targetGroup = signal(null);

    public onDragStarted(node: TreeLikeFlatNode<Record>) {
        this.sourceGuid.set(node.id);
        this.sourceGroup.set(node.uniqueId.replace(`-${node.id}`, ''));
        this.dragStarted.set(true);
        this.appendOnly.set(true);
    }

    public onDragEnded() {
        this.dragStarted.set(false);
        this.appendOnly.set(false);
    }

    public onDragEnter(node: TreeLikeFlatNode<Record>, group?: boolean) {
        if (group) {
            this.targetGuid.set(node.id);
            this.targetGroup.set(node.id);
        } else {
            this.targetGuid.set(node.id);
            this.targetGroup.set(node.uniqueId.replace(`-${node.id}`, ''));
        }
    }
}
